export const firebaseConfig = {
    apiKey: "AIzaSyDy4GEyGyNSoANVQNmUZSS2_ifVjSOGeHA",
    authDomain: "wasteverse.firebaseapp.com",
    databaseURL: "https://wasteverse-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "wasteverse",
    storageBucket: "wasteverse.appspot.com",
    messagingSenderId: "204809708414",
    appId: "1:204809708414:web:cebbea4c011902c30a492f",
    measurementId: "G-68642VX5Z0"
};